import UpcomingLiveEventsContainer from './UpcomingLiveEventsContainer'

export default UpcomingLiveEventsContainer
